import React from 'react';

export default class Page11 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToIdentifyPersonalLearningStyles');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">


                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">Further Information</span>
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToIdentifyYourPersonalMeaning')}>How
                                                        to identify your personal meaning</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToDevelopOthers')}>How
                                                        to develop others</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}>How
                                                        to get the most out of yourself.</div></li>


                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> Gardner, H.
                                                    (1983).<span className="subtiltereg"> Frames of Mind: The Theory of Multiple Intelligences.</span> Basic
                                                    Books.</p></li>
                                                <li><p className="further_info_content">Kolb, D. (1981)<span
                                                    className="subtiltereg"> Learning styles and disciplinary differences.</span> in
                                                    A. Chickering (ed.) The Modern American
                                                    College, San Francisco: Jossey-Bass.</p></li>
                                                <li><p className="further_info_content">Barrick, M.
                                                    R., &amp; Mount, M. K. (2006). The big five personality
                                                    dimensions and job performance: a metaanalysis.
                                                    <span
                                                        className="subtiltereg">Personnel psychology,</span> 44(1),
                                                    1-26.
                                                </p></li>
                                                <li><p className="further_info_content">Kolb, D. A.
                                                    (1999). <span
                                                        className="subtiltereg">Learning style inventory.</span> McBer
                                                    and Company.</p></li>


                                            </ol>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page10')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}